import React from 'react';

interface AuthSubmitButtonProps {
  children: React.ReactNode;
  loadingLabel?: string;
  isLoading?: boolean;
  disabled?: boolean;
  type?: 'submit' | 'button';
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
}

// Auth primary CTA. Same sky-600 + focus-ring styling as the public site's
// CTAs so the visual language is consistent across surfaces.
const AuthSubmitButton: React.FC<AuthSubmitButtonProps> = ({
  children,
  loadingLabel,
  isLoading = false,
  disabled = false,
  type = 'submit',
  onClick,
  variant = 'primary',
}) => {
  const baseClasses =
    'w-full inline-flex items-center justify-center gap-2 px-5 py-3 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 focus-visible:ring-offset-2 focus-visible:ring-offset-black disabled:opacity-50 disabled:cursor-not-allowed';
  const variantClasses =
    variant === 'primary'
      ? 'bg-sky-600 hover:bg-sky-500 text-white'
      : 'border border-white/15 hover:border-white/30 text-white';

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || isLoading}
      className={`${baseClasses} ${variantClasses}`}
    >
      {isLoading ? (
        <>
          <svg
            className="animate-spin h-4 w-4 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
          {loadingLabel ?? children}
        </>
      ) : (
        children
      )}
    </button>
  );
};

export default AuthSubmitButton;
